import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const bladder: AnswerPathTreeNode = {
  path: 'bladder',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredBladderDetails }],
};
